import { useTranslation } from '../context/TranslationContext';
import './Legal.css';

export default function GDPR() {
  const { t } = useTranslation();

  return (
    <div className="legal-page">
      <div className="legal-header">
        <h1>{t('gdprCompliance', 'GDPR Compliance')}</h1>
      </div>
      <div className="legal-content">
        <section className="legal-section">
          <h2>{t('dataRights', 'Data Rights')}</h2>
          <p>{t('gdprIntro', 'We are committed to protecting your personal data and ensuring compliance with the General Data Protection Regulation (GDPR).')}</p>
        </section>
        <section className="legal-section">
          <h2>{t('rightToAccess', 'Right to Access')}</h2>
          <p>{t('accessDesc', 'You have the right to access your personal data and obtain information about how it is processed.')}</p>
        </section>
        <section className="legal-section">
          <h2>{t('rightToErasure', 'Right to Erasure')}</h2>
          <p>{t('erasureDesc', 'You have the right to request the deletion of your personal data under certain conditions.')}</p>
        </section>
        <section className="legal-section">
          <h2>{t('contactUsGdpr', 'Contact Us')}</h2>
          <p>{t('contactGdprDesc', 'If you have any questions or concerns about your data rights or our GDPR compliance, please contact us.')}</p>
        </section>
      </div>
    </div>
  );
}
